// this is src/components/DateFilterButtons.js
import React from 'react';
import './DateFilterButtons.css';

const DateFilterButtons = ({ selectedPeriod, onPeriodChange }) => {
  const periods = [
    { key: '1W', label: '1W', days: 7 },
    { key: '1M', label: '1M', days: 30 },
    { key: '3M', label: '3M', days: 90 },
    { key: '6M', label: '6M', days: 180 },
    { key: '1Y', label: '1Y', days: 365 },
    { key: '3Y', label: '3Y', days: 1095 },
    { key: '5Y', label: '5Y', days: 1825 },
    { key: 'MAX', label: 'MAX', days: null }
  ];

  return (
    <div className="date-filter-buttons-container">
      <div className="date-filter-buttons">
        {periods.map((period) => (
          <button
            key={period.key}
            className={`date-filter-btn ${selectedPeriod === period.key ? 'active' : ''}`}
            onClick={() => onPeriodChange(period.key)}
          >
            {period.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DateFilterButtons;